import { render } from "./WelcomeRings.vue?vue&type=template&id=d98ee19c&scoped=true"
import script from "./WelcomeRings.vue?vue&type=script&lang=js"
export * from "./WelcomeRings.vue?vue&type=script&lang=js"

import "./WelcomeRings.vue?vue&type=style&index=0&id=d98ee19c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98ee19c"]])

export default __exports__